module.exports = __webpack_public_path__ + "static/media/Team 34 Metropolitan Dynamics.a089e1a4.png";